import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import {EventDTO, EventReservationRequestDTO, XploreItemDTO} from "../../../shared/object/xplorer-be-parsed-classes";
import {ReservationService} from "../../../services/reservation.service";
import {AuthService} from "../../../services/auth/auth.service";
import {ToastService} from "../../../services/toast/toast.service";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { NgClass } from '@angular/common';

@Component({
    selector: 'xplorer-bowser-reservation-popup',
    templateUrl: './reservation-popup.component.html',
    styleUrls: ['./reservation-popup.component.css'],
    imports: [ReactiveFormsModule, NgClass, TranslateModule]
})
export class ReservationPopupComponent implements OnInit, OnChanges{

  @Input()
  alreadyReserved: boolean;

  @Input()
  xploreItem: XploreItemDTO;

  @Input()
  toggle: boolean;

  @Output()
  reservationConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  actualEvent: EventDTO;
  isOpen = false;

  isLoading: boolean = false;

  eventReservationRequestDTO: EventReservationRequestDTO = undefined;

  reservationFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    surname: new FormControl('', Validators.required),
    phoneNumber: new FormControl(''),
    additionalNumberOfPeople: new FormControl(0),
    additionalInfo: new FormControl('')
  });

  public reservationService: ReservationService = inject(ReservationService);
  public authService: AuthService = inject(AuthService);
  public toastService: ToastService = inject(ToastService);
  private translate: TranslateService = inject(TranslateService);


  ngOnInit(): void {
    if(this.xploreItem.itemType !== 'EVENT'){
      throw new Error('Only events can be reserved')
    } else {
      this.actualEvent = this.xploreItem as EventDTO;
    }
  }

  openModal() {
    this.isOpen = true;
    this.isLoading = false;
  }

  closeModal() {
    this.isOpen = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['toggle'] && !changes['toggle'].firstChange){
      this.openModal();
    }
  }

  confirmReservation() {
    this.isLoading = true;
    this.reservationService.reserveEvent(this.eventReservationRequestDTO)
      .pipe()
      .subscribe({
        next: eventReservationDTO => {
          console.debug(eventReservationDTO);
          this.isLoading = false;
          this.toastService.showCustomSuccessToast(this.translate.instant('event.reservation-confirmed'));
          this.closeModal();
          this.reservationConfirmed.emit(true);
        },
        error: error => {
          this.isLoading = false;
          console.error(error);
          this.toastService.showErrorToast(this.translate.instant('event.error-registering'));
          this.closeModal();
        }
      });
  }

  deleteReservation() {
    this.isLoading = true;
    this.reservationService.deleteReservation(this.xploreItem.id)
      .pipe()
      .subscribe({
        next: _ => {
          this.closeModal()
          this.reservationConfirmed.emit(true);
        },
        error: error => {
          this.toastService.showErrorToast(this.translate.instant(''));
          this.closeModal()
        }
      });
  }

  submitReservation(reservationFormGroup: FormGroup) {

    let userId = this.authService.getUser()?.userId;

    this.eventReservationRequestDTO = {
      name: reservationFormGroup.controls['name'].value,
      surname: reservationFormGroup.controls['surname'].value,
      phoneNumber: reservationFormGroup.controls['phoneNumber'].value,
      additionalNumberOfPeople: reservationFormGroup.controls['additionalNumberOfPeople'].value,
      additionalInfo: reservationFormGroup.controls['additionalInfo'].value,
      eventId: this.xploreItem.id,
      userId: userId,
    }

    this.confirmReservation();
  }

  shouldShowError(fieldName: string) {
    return this.reservationFormGroup.get(fieldName).invalid
      && (this.reservationFormGroup.get(fieldName).dirty || this.reservationFormGroup.get(fieldName).touched)
  }
}
